import { Controller, useForm } from 'react-hook-form';
import {
  ConsultationQuestionFormSchema,
  DashboardHistoryPUBQuestionFormProps,
} from './DashboardHistoryENTQuestionForm.types';
import { getConsultationQuestionSchema } from './DashboardHistoryENTQuestionForm.schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation, useQueryClient } from 'react-query';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import {
  SEND_CONSULTATION_QUESTION_QUERY_KEY,
  sendConsultationQuestionQuery,
} from './DashboardHistoryENTQuestionForm.query';
import { useNavigate } from 'react-router-dom';
import { SendConsultationQuestionRequestData } from '../../../../../../../types/api/endpoints/consultations/questions.types';
import TextArea from '../../../../../../commons/TextArea/TextArea';
import Button from '../../../../../../designSystem/Button/Button';
import { ButtonColor } from '../../../../../../designSystem/Button/Button.types';

export default ({ consultationId }: DashboardHistoryPUBQuestionFormProps) => {
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const formProps = useForm<ConsultationQuestionFormSchema>({
    resolver: yupResolver(getConsultationQuestionSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    formState: { isValid, errors },
  } = formProps;

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, SendConsultationQuestionRequestData>(
    (data) => sendConsultationQuestionQuery(data),
    {
      mutationKey: SEND_CONSULTATION_QUESTION_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        navigate(0);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = handleSubmit((data) => mutate({ ...data, consultationId }));

  return (
    <>
      <Controller
        name={'question'}
        render={({ field: { onChange, value } }) => (
          <TextArea
            className="dashboard-history__question-textarea"
            name="answer"
            placeholder={'Votre question...'}
            error={errors['question']?.message as string}
            // @ts-ignore
            value={value}
            // onPressEnter={onSubmit}
            {...{ onChange }}
            isCompany
            onlyInput
          />
        )}
        {...{ control }}
      />
      <Button
        className="dashboard-history__question-button"
        style={{ display: isValid ? 'unset' : 'none' }}
        onClick={onSubmit}
        color={ButtonColor.Secondary}>
        Envoyer
      </Button>
    </>
  );
};
